import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { WidgetGuard } from 'features/types'

const TagsEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const insightData = widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]
  const isEmpty = (insightData?.set?.length ?? 0) === 0

  if (isEmpty) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default TagsEmptyResultGuard
